export const berryNamespaces = [
  'strawberry',
  'blackberry',
  'snowberry',
  'raspberry',
  'blueberry',
  'elderberry',
  'mulberry',
  'grape',
  'salmonberry',
  'cloudberry',
  'snozzberry',
  'marvinberry',
  'frankenberry',
  'lingonberry',
  'crunchberry',
  'halleberry',
  'oopsallberry',
  'cranberry',
  'banana',
  'avocado',
  'winterberry',
  'coffee',
  'conkerberry',
  'gooseberry',
  'guava',
  'huckleberry',
  'sugarplum',
  'berriedtreasure',
  'berrykeoghan',
  'boysenberry',
  'dragonfruit',
  'papaya',
  'passionfruit',
  'pomegranate',
  'sitrusberry',
  'lumberry',
  'berryallan',
  'knottsberry'
] as const

export type BerryNamespace = (typeof berryNamespaces)[number]
export const berryNamespacesSet = berryNamespaces.reduce(
  (set, namespace) => set.add(namespace),
  new Set<BerryNamespace>()
)

export type ValidKubernetesNamespace = BerryNamespace | 'default'
export const validKubernetesNamespaces: ValidKubernetesNamespace[] = [...berryNamespaces, 'default']
export const validKubernetesNamespacesSet = validKubernetesNamespaces.reduce(
  (set, namespace) => set.add(namespace),
  new Set<ValidKubernetesNamespace>()
)

export type ValidSubdomain = BerryNamespace | 'staging'

export const NAMESPACES_TO_HEX: Record<BerryNamespace, string> = {
  strawberry: 'FC5A8D',
  blackberry: '4D0135',
  snowberry: 'CFE061',
  raspberry: 'E30B5D',
  blueberry: '4F86F7',
  elderberry: '17182B',
  mulberry: 'C54B8C',
  grape: '6F2DA8',
  salmonberry: 'F7C493',
  cloudberry: 'FFAE42',
  snozzberry: 'A50B5E',
  marvinberry: 'E25098',
  frankenberry: '7851A9',
  lingonberry: 'FFA089',
  crunchberry: '93DD6E',
  halleberry: '5F4FD6',
  oopsallberry: '00BFFF',
  cranberry: 'AB1345',
  banana: 'F2D100',
  avocado: '84BF68',
  winterberry: '94B1FF',
  coffee: '6E260E',
  conkerberry: '2C0588',
  gooseberry: 'FF971C',
  guava: 'FF763D',
  huckleberry: '00803A',
  sugarplum: 'FF5E9C',
  berriedtreasure: 'E1BD02',
  berrykeoghan: '30DA03',
  boysenberry: '0354DA',
  dragonfruit: '66DC20',
  papaya: 'FFF636',
  passionfruit: '6D24A3',
  pomegranate: '9F2424',
  sitrusberry: 'FDFF69',
  lumberry: 'E0E221',
  berryallan: 'EA3820',
  knottsberry: 'B820EA'
}

export const NAMESPACES_TO_EMOJI: Record<BerryNamespace, string> = {
  strawberry: '🍓',
  blackberry: '📱',
  snowberry: '❄️',
  raspberry: '🥧',
  blueberry: '🫐',
  elderberry: '👴🏻',
  mulberry: '🐛',
  grape: '🍇',
  salmonberry: '🐟',
  cloudberry: '☁️',
  snozzberry: '🍫',
  marvinberry: '🎙',
  frankenberry: '🧟',
  lingonberry: '🍒',
  crunchberry: '🧢',
  halleberry: '🌩',
  oopsallberry: '🥣',
  cranberry: '🐱',
  banana: '🍌',
  avocado: '🥑',
  winterberry: '🌨',
  coffee: '☕',
  conkerberry: '😵‍💫',
  gooseberry: '🪿',
  guava: '🍐',
  huckleberry: '📙',
  sugarplum: '🧚',
  berriedtreasure: '🏴‍☠️',
  berrykeoghan: '☘️',
  boysenberry: '👦',
  dragonfruit: '🐲',
  papaya: '👨‍🍼',
  passionfruit: '💔🎤',
  pomegranate: '🪦',
  sitrusberry: '❤️‍🩹',
  lumberry: '💊',
  berryallan: '⚡',
  knottsberry: '🎢'
}

export function configNamespaceToSubdomain(
  ns: ValidKubernetesNamespace | 'local' | 'test',
  isProduction?: boolean
): ValidSubdomain | 'local' | 'test' | undefined {
  switch (ns) {
    case 'default':
      return !isProduction ? 'staging' : undefined
    default:
      return ns
  }
}
